import request from '../utils/request';

// 定制服务 API
export const customServiceApi = {
  // 获取定制服务列表
  getCustomServiceList: (params) => request.get('/custom-service/list', { params }),
  
  // 创建定制服务
  createCustomService: (data) => request.post('/custom-service/create', data),
  
  // 更新定制服务
  updateCustomService: (id, data) => request.put(`/custom-service/${id}`, data),
  
  // 删除定制服务
  deleteCustomService: (id) => request.delete(`/custom-service/${id}`),
  
  // 获取定制服务详情
  getCustomServiceDetail: (id) => request.get(`/custom-service/${id}`)
};

// 陪逛服务 API
export const accompanyServiceApi = {
  // 获取陪逛服务列表
  getAccompanyServiceList: (params) => request.get('/accompany-service/list', { params }),
  
  // 创建陪逛服务
  createAccompanyService: (data) => request.post('/accompany-service/create', data),
  
  // 更新陪逛服务
  updateAccompanyService: (id, data) => request.put(`/accompany-service/${id}`, data),
  
  // 删除陪逛服务
  deleteAccompanyService: (id) => request.delete(`/accompany-service/${id}`),
  
  // 获取陪逛服务详情
  getAccompanyServiceDetail: (id) => request.get(`/accompany-service/${id}`)
}; 